import { createIconComponent } from '../../factory/create-icon-component';
export const WarehouseUnitsIcon = createIconComponent(
  'WarehouseUnitsIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 9.50001V17.2501C2.5 17.9468 2.5 18.2951 2.54329 18.587C2.80182 20.3298 4.17025 21.6982 5.91308 21.9568C6.20494 22.0001 6.55329 22.0001 7.25 22.0001L9.19182 22M1 11L7.47452 4.52549C9.05858 2.94142 9.85062 2.14939 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14939 14.9414 2.94142 16.5255 4.52549L23 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6504 12.0331L16.8344 10.3435C16.3482 10.0518 16.1051 9.90595 15.8456 9.84896C15.6161 9.79856 15.3783 9.79856 15.1488 9.84896C14.8893 9.90595 14.6462 10.0518 14.16 10.3435L11.344 12.0331L11.344 12.0331C10.8839 12.3092 10.6538 12.4472 10.4867 12.6373C10.3388 12.8055 10.2273 13.0024 10.1591 13.2158C10.0822 13.4569 10.0822 13.7252 10.0822 14.2618V16.7337C10.0822 17.2703 10.0822 17.5386 10.1591 17.7797C10.2273 17.9931 10.3388 18.19 10.4867 18.3582C10.6538 18.5482 10.8839 18.6863 11.344 18.9624L11.344 18.9624L11.8872 19.2883L13.6922 20.3713L14.1251 20.631L14.1251 20.631C14.6233 20.9299 14.8724 21.0794 15.1378 21.1358C15.3726 21.1856 15.6156 21.1829 15.8492 21.1276C16.1133 21.0652 16.3589 20.91 16.8501 20.5998L20.5964 18.2337C20.6244 18.2161 20.65 18.2028 20.6788 18.1877L20.6852 18.1845C20.8494 18.099 20.9122 17.8962 20.9122 17.7111V14.4147V14.2618C20.9122 13.7252 20.9122 13.4569 20.8352 13.2158C20.7671 13.0024 20.6556 12.8055 20.5077 12.6373C20.3406 12.4472 20.1105 12.3092 19.6504 12.0331Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0601 14.1444L16.1624 12.2485"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4969 15.7685L20.3704 12.7902M15.4969 15.7685L10.6234 12.7902M15.4969 15.7685V21.1835"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
